export default "__VITE_ASSET__BaUO2Zt9__"